export default "__VITE_ASSET__AyoHyCJ6oM$w3VtZBasLKg__"